import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=72db5af0&scoped=true"
import script from "./FileManager.vue?vue&type=script&lang=js"
export * from "./FileManager.vue?vue&type=script&lang=js"
import style1 from "./FileManager.vue?vue&type=style&index=1&id=72db5af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72db5af0",
  null
  
)

export default component.exports